























































import { computed, defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "Pagination",
  props: {
    totalPages: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
  },
  setup(props, { emit }) {
    const goToPage = (page) => {
      if (page !== props.currentPage && page > 0 && page <= props.totalPages) {
        emit('go-to-page', page);
      }
    };

    const goToFirstPage = () => {
      if (props.currentPage !== 1) {
        emit('go-to-page', 1);
      }
    };

    const goToLastPage = () => {
      if (props.currentPage !== props.totalPages) {
        emit('go-to-page', props.totalPages);
      }
    };

     const visiblePages = computed(() => {
      // Số page là 5 thì cho hiện hết
      if (props.totalPages <= 5) {
        return Array.from({ length: props.totalPages }, (_, i) => i + 1);
      }

      const pages = [];
      pages.push(1);

      if (props.currentPage <= 3) {
        pages.push(2);
        pages.push(3);
        if (props.currentPage === 3) {
          pages.push(4);
        }
        pages.push("...");
      } else if (props.currentPage >= props.totalPages - 2) {
        pages.push("...");

        if (props.currentPage === props.totalPages - 2) {
          pages.push(props.totalPages - 3);
        }

        pages.push(props.totalPages - 2);
        pages.push(props.totalPages - 1);
      } else if (props.currentPage === 4 && props.totalPages > 6) {
        pages.push(2);
        pages.push(3);
        pages.push(4);
        pages.push(5);
        pages.push("...");
      } else if (
        props.currentPage === props.totalPages - 3 &&
        props.totalPages > 7
      ) {
        pages.push("...");
        pages.push(props.totalPages - 4);
        pages.push(props.totalPages - 3);
        pages.push(props.totalPages - 2);
        pages.push(props.totalPages - 1);
      } else {
        pages.push("...");
        pages.push(props.currentPage - 1);
        pages.push(props.currentPage);
        pages.push(props.currentPage + 1);
        pages.push("...");
      }

      if (pages[pages.length - 1] !== props.totalPages) {
        pages.push(props.totalPages);
      }

      return pages;
    });

    return {
      goToPage,
      goToFirstPage,
      goToLastPage,
      visiblePages,
    };
  }
});
